import { render, staticRenderFns } from "./BillDetailsPage.vue?vue&type=template&id=2e12d57e&scoped=true"
import script from "./BillDetailsPage.vue?vue&type=script&lang=js"
export * from "./BillDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BillDetailsPage.vue?vue&type=style&index=0&id=2e12d57e&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12d57e",
  null
  
)

export default component.exports